import { CUIDARI_ACCESS_GATE_COPY } from '@francisquiniai/cuidari-core/auth'
import { GateBackButton, GateNoticeCard } from './gateUi'
import { CredentialsStage, MfaStage, ResetStage } from './loginStages'
import { icon } from './shared'
import { useLoginFlow } from './useLoginFlow'

function LoginCohortPanel() {
  const copy = CUIDARI_ACCESS_GATE_COPY.login
  return (
    <div className="login-cohort-panel">
      <span>{icon('verified_user')}</span>
      <div>
        <strong>{copy.cohortTitle}</strong>
        <p>{copy.cohortBody}</p>
        <div className="login-cohort-panel__pills">
          <em>{icon('flag')} {copy.cohortPills[0]}</em>
          <em>{icon('forum')} {copy.cohortPills[1]}</em>
          <em>{icon('group_add')} {copy.cohortPills[2]}</em>
        </div>
      </div>
    </div>
  )
}

export function LoginForm({ onBack }: { onBack: () => void }) {
  const flow = useLoginFlow()
  const { stage, error, notice } = flow
  const copy = CUIDARI_ACCESS_GATE_COPY.login

  const stageTitle =
    stage === 'mfa'
      ? 'Verificação'
      : stage === 'reset'
        ? 'Redefinir senha'
        : copy.title

  return (
    <section className="login-card" data-testid="login-form">
      <p className="login-kicker">{copy.kicker}</p>
      <h2>{stageTitle}</h2>
      <p className="login-card__body">{copy.body}</p>

      {stage === 'credentials' && <LoginCohortPanel />}

      {error && (
        <GateNoticeCard
          notice={{ tone: 'danger', title: 'Erro', body: error }}
        />
      )}
      {notice && (
        <GateNoticeCard
          notice={{ tone: 'success', title: 'Tudo certo', body: notice }}
        />
      )}

      {stage === 'credentials' && <CredentialsStage flow={flow} />}

      {stage === 'mfa' && <MfaStage flow={flow} />}

      {stage === 'reset' && <ResetStage flow={flow} />}

      <GateBackButton onClick={onBack} />
    </section>
  )
}
